import React, { useState } from 'react';
import InquiryModal from '../../components/features/InquiryModal';
import Button from '../../components/ui/Button';
import './Demo.css';

const Demo = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <div className="demo-page">
            <InquiryModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} type="DEMO" />

            <div className="page-hero">
                <div className="container">
                    <h1 className="page-title">데모 요청</h1>
                    <p className="page-subtitle">
                        관리자 페이지와 사용자 화면을 직접 체험해보세요.<br />
                        데모 계정은 보안상 관리자가 직접 생성하여 발급해 드립니다.
                    </p>
                </div>
            </div>

            <div className="container demo-container">
                <div className="demo-card">
                    <h2 style={{ marginBottom: '1.5rem', fontSize: '1.5rem' }}>체험 계정 신청</h2>
                    <p style={{ marginBottom: '2rem', color: '#666', lineHeight: '1.6' }}>
                        버튼을 눌러 신청 양식을 작성해주시면,<br />
                        담당자가 확인 후 <strong>이메일이나 문자</strong>로 체험 계정 정보를 보내드립니다.<br />
                        (영업일 기준 24시간 이내 발송)
                    </p>

                    <div className="flex justify-center my-6">
                        <Button
                            onClick={() => setIsModalOpen(true)}
                            variant="primary"
                            size="md"
                            className="text-[1.05rem] font-extrabold px-8 py-4 rounded-full shadow-glow flex items-center justify-center gap-2.5 transition-transform hover:-translate-y-1"
                        >
                            💻 데모 계정 신청하기
                        </Button>
                    </div>

                    <div style={{ marginTop: '3rem', fontSize: '0.9rem', color: '#999' }}>
                        * 긴급한 문의가 있으시다면 고객센터(010-5485-3991)로 연락주세요.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Demo;
